import AppStore from "../stores/AppStore";
import MailApi from "./MailApi";
import { mailApiEndpoint } from "../config/mail-api-config";
import MeasureApi from "./MeasureApi";
import BusinessUnitApi from "./BusinessUnitApi";
import DepartmentApi from "./DepartmentApi";
import ObjectiveApi from "./ObjectiveApi";
import ScorecardApi from "./ScorecardApi";
import AuthApi from "./AuthApi";
import UserApi from "./UserApi";
import MeasureAuditApi from "./MeasureAuditApi";
import FolderApi from "./FolderApi";
import FolderFileApi from "./FolderFileApi";
import UploadManagerApi from "./UploadManagerApi";
import CompanyObjectiveApi from "./CompanyObjectiveApi";
import CompanyMeasureApi from "./CompanyMeasureApi";
import CompanyMeasureAuditApi from "./CompanyMeasureAuditApi";
import CompanyScorecardMetadataApi from "./CompanyScorecardMetadataApi";
import CompanyScorecardReviewApi from "./CompanyScorecardReviewApi";
import IndividualScorecardApi from "./IndividualScorecardApi";
import StrategicThemeApi from "./StrategicThemeApi";
import IndividualScorecardReviewApi from "./IndividualScorecardReviewApi";
import DivisionApi from "./DivisionApi";
import ProjectManagementApi from "./ProjectManagementApi";
import FeedbackApi from "./FeedbackApi";
import GeneralTaskApi from "./GeneralTaskApi";
import ScorecardArchiveApi from "./ScorecardArchiveApi";

//360
import CommitteeApi from "./three-sixty-apis/Committee";
import CommitteeRatingApi from "./three-sixty-apis/CommitteeRatingApi";
import LeadershipApi from "./three-sixty-apis/LeadershipApi";
import LeadershipRatingApi from "./three-sixty-apis/LeadershipRatingApi";
import MessagesApi from "./three-sixty-apis/messages/MessagesApi";
import ProjectApi from "./three-sixty-apis/ProjectApi";
import ProjectRatingApi from "./three-sixty-apis/ProjectRatingApi";
import RatingAssignmentApi from "./three-sixty-apis/RatingAssignmentApi";
import RatingSessionApi from "./three-sixty-apis/RatingSessionApi";
import ServiceApi from "./three-sixty-apis/ServiceApi";
import ServiceRatingApi from "./three-sixty-apis/ServiceRatingApi";
import TemplateApi from "./three-sixty-apis/TemplateApi";
import TemplateRatingApi from "./three-sixty-apis/TemplateRatingApi";
import ValueApi from "./three-sixty-apis/ValueApi";
import ValueRatingApi from "./three-sixty-apis/ValueRatingApi";
import ChatApi from "./three-sixty-apis/messages/ChatApi";
import PersonalDevelopmentApi from "./PersonalDevelopmentApi";
import QualificationsApi from "./QualificationsApi";
import TrainingRequestApi from "./TrainingRequestApi";
import TrainingBudgetApi from "./TrainingBudgetApi";

export const apiPathCompanyLevel = (
  category:
    | "projects"
    | "portfolios"
    | "scorecards"
    | "businessUnits"
    | "divisions"
    | "departments"
    | "users"
    | "folders"
    | "folderFiles"
    | "personalDevelopment"
    | "personalDevelopmentQualifications"
    | "TrainingRequests"
    | "trainingBudget"
): string => {
  return `companies/mw21n2gir3bjvUCQeQgN/${category}`;
};

export const apiPathScorecardLevel = (
  scorecardId: string,
  category:
    | "scorecardMetadata"
    | "scorecardDraftReviews"
    | "scorecardQuarter1Reviews"
    | "scorecardQuarter2Reviews"
    | "scorecardQuarter3Reviews"
    | "scorecardQuarter4Reviews"
    | "measures"
    | "measuresAudit"
    | "objectives"
    | "strategicThemes"
    | "companyObjectives"
    | "companyMeasuresAudit"
    | "companyMeasures"
    | "departmentObjectives"
    | "departmentMeasures"
    | "departmentMeasuresAudit"
    | "divisionObjectives"
    | "divisionMeasures"
    | "divisionMeasuresAudit"
    | "scorecardArchives"
): string => {
  return `${apiPathCompanyLevel("scorecards")}/${scorecardId}/${category}`;
};

export const apiPathProjectLevel = (
  projectId: string,
  category: "tasks" | "risks" | "logs"
): string => {
  return `${"projects"}/${projectId}/${category}`;
};

export default class AppApi {
  mail: MailApi;
  auth: AuthApi;
  user: UserApi;

  objective: ObjectiveApi;
  measure: MeasureApi;
  measureAudit: MeasureAuditApi;

  scorecard: ScorecardApi;
  individualScorecard: IndividualScorecardApi;
  individualScorecardReview: IndividualScorecardReviewApi;

  strategicTheme: StrategicThemeApi;

  companyObjective: CompanyObjectiveApi;
  companyMeasure: CompanyMeasureApi;
  companyMeasureAudit: CompanyMeasureAuditApi;

  companyScorecardMetadata: CompanyScorecardMetadataApi;
  companyScorecardReview: CompanyScorecardReviewApi;

  division: DivisionApi;
  department: DepartmentApi;
  businessUnit: BusinessUnitApi;

  // scorecard archive implementation
  scorecardArchive: ScorecardArchiveApi;

  folder: FolderApi;
  folderFile: FolderFileApi;

  uploadManager: UploadManagerApi;
  projectManagement: ProjectManagementApi;
  feedback: FeedbackApi;
  generalTask: GeneralTaskApi;

  //360
  value: ValueApi;
  leadership: LeadershipApi;
  messages: MessagesApi;
  ratingAssignments: RatingAssignmentApi;
  valueRating: ValueRatingApi;
  leadershipRating: LeadershipRatingApi;
  projects: ProjectApi;
  service: ServiceApi;
  committee: CommitteeApi;
  serviceRating: ServiceRatingApi;
  committeeRating: CommitteeRatingApi;
  projectRating: ProjectRatingApi;
  chatApi: ChatApi;
  template: TemplateApi;
  ratingSession: RatingSessionApi; //will be removed
  templates: TemplateApi;
  templateRating: TemplateRatingApi;

  //personal development
  personalDevelopment: PersonalDevelopmentApi;
  qualifications: QualificationsApi;
  trainingRequest: TrainingRequestApi;
    trainingBudget: TrainingBudgetApi;


  constructor(store: AppStore) {
    this.mail = new MailApi();
    this.auth = new AuthApi(this, store);

    // Company Level Paths
    this.division = new DivisionApi(this, store);
    this.department = new DepartmentApi(this, store);
    this.businessUnit = new BusinessUnitApi(this, store);
    this.scorecard = new ScorecardApi(this, store);
    this.user = new UserApi(this, store);
    this.folder = new FolderApi(this, store);
    this.folderFile = new FolderFileApi(this, store);

    // File Upload Manager
    this.uploadManager = new UploadManagerApi(this, store);

    // Scorecard Level Paths
    this.individualScorecard = new IndividualScorecardApi(this, store);
    this.individualScorecardReview = new IndividualScorecardReviewApi(
      this,
      store
    );
    this.objective = new ObjectiveApi(this, store);
    this.measure = new MeasureApi(this, store);
    this.measureAudit = new MeasureAuditApi(this, store);
    this.strategicTheme = new StrategicThemeApi(this, store);
    this.scorecardArchive = new ScorecardArchiveApi(this, store);

    // Company APIs
    this.companyObjective = new CompanyObjectiveApi(this, store);
    this.companyMeasure = new CompanyMeasureApi(this, store);
    this.companyMeasureAudit = new CompanyMeasureAuditApi(this, store);
    this.companyScorecardMetadata = new CompanyScorecardMetadataApi(
      this,
      store
    );
    this.companyScorecardReview = new CompanyScorecardReviewApi(this, store);
    // Project Managements APIs
    this.projectManagement = new ProjectManagementApi(this, store);
    // Feedback APIs
    this.feedback = new FeedbackApi(this, store);

    this.generalTask = new GeneralTaskApi(this, store);

    //personal development
    this.qualifications = new QualificationsApi(this, store);
    this.personalDevelopment = new PersonalDevelopmentApi(this, store);
    this.trainingRequest = new TrainingRequestApi(this, store);
        this.trainingBudget = new TrainingBudgetApi(this, store);
    //360
    this.value = new ValueApi(this, store);
    this.leadership = new LeadershipApi(this, store);
    this.messages = new MessagesApi(this, store);
    this.valueRating = new ValueRatingApi(this, store);
    this.leadershipRating = new LeadershipRatingApi(this, store);
    this.ratingAssignments = new RatingAssignmentApi(this, store);
    this.projects = new ProjectApi(this, store);
    this.service = new ServiceApi(this, store);
    this.committee = new CommitteeApi(this, store);
    this.committeeRating = new CommitteeRatingApi(this, store);
    this.serviceRating = new ServiceRatingApi(this, store);
    this.projectRating = new ProjectRatingApi(this, store);
    this.chatApi = new ChatApi(this, store);
    this.template = new TemplateApi(this, store);
    this.templateRating = new TemplateRatingApi(this, store);
    this.ratingSession = new RatingSessionApi(this, store);
    this.templates = new TemplateApi(this, store);
  }
}
